<div class="my-4">
  <div class="dropdown-mobile--spacer pe-sm-4 mb-2">
    <span class="ds-heading--s">{{ 'help.getHelp' | cxTranslate }}</span>
  </div>
  <div class="list-group">
    <ng-container *ngFor="let helpIconLinksNodes of navigationComponentService.mapToArray(helpIconLinks)">
      <ng-container *ngFor="let helpIconLink$ of helpIconLinksNodes">
        <ng-container *ngIf="helpIconLink$ | async as helpIconLink">
          <ng-container *ngIf="helpIconLink.url">
            <cx-generic-link
              [attr.data-link-name]="helpIconLink.name"
              [class]="'list-group-item list-group-item-action dropdown-mobile--spacer pe-sm-4 btn ds-cursor--pointer border-none mb-1'"
              [target]="helpIconLink.target" [url]="helpIconLink.url">
              <span>{{ helpIconLink.linkName }}</span>
            </cx-generic-link>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <span [attr.data-cy]="'dcp-support-form'"
          (click)="dcpSupportFormService.open();closeDropdown()"
          (keydown.enter)="dcpSupportFormService.open();closeDropdown()"
          [class]="'list-group-item list-group-item-action dropdown-mobile--spacer pe-sm-4 btn ds-cursor--pointer border-none'"
          tabindex="0">
                <span>{{ 'help.contactUs' | cxTranslate }}</span>
              </span>
  </div>
</div>
